import React from 'react';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';
import RegulatoryHeaderUS from '../RegulatoryHeaderUS/RegulatoryHeaderUS';

import styles from './RegulatoryHeaderUSMI.scss';

const RegulatoryHeaderUSMI: React.FC<Props> = ({
  regulatory_header: [
    {
      texts: [text, ...texts],
      icons: [icon, ...icons]
    }
  ]
}) => (
  <>
    <div className={styles.odawa}>
      <span className={styles.regulatoryText}>
        <CMSHTML content={text.content} />
      </span>
      <CMSImage {...icon} />
    </div>
    <RegulatoryHeaderUS
      regulatory_header={[{ texts, icons }] as unknown as Props['regulatory_header']}
    />
  </>
);

export default RegulatoryHeaderUSMI;
